import React from 'react';
import Navbar from '../../components/navbar';
import OpcionesMantenimiento from '../../components2/opcionesMantenimiento';

function Mantenimiento () {
    return (
        <OpcionesMantenimiento />
    )
}

export default Mantenimiento;